var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"number","min":_vm.min,"max":_vm.max,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.input($event)},"change":function($event){return _vm.change($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }